import {Directive, ElementRef, HostListener, inject} from '@angular/core';

@Directive({
  selector: 'button[mxPreventFocus], a[mxPreventFocus]'
})
export class PreventFocusDirective {

  private readonly element: HTMLButtonElement | HTMLAnchorElement = inject(ElementRef).nativeElement;

  @HostListener('click') onClick(): void {
    this.element.blur();
  }
}
